import React from 'react';
import "./about.css";

const About = () => {
  return (
    <section className="about section" id="about">
    </section>
  );
}

export default About;